import { Shield, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 mesh-hero" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl border border-slate-200 p-8 sm:p-10 relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#FF7A00]/10 blur-3xl" />
        <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full bg-[#003DA5]/10 blur-3xl" />
        <div className="relative">
          <div className="w-14 h-14 rounded-2xl bg-[#003DA5] flex items-center justify-center text-white shadow-lg mb-5">
            <Shield className="w-7 h-7" />
          </div>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900">Welcome back</h1>
          <p className="mt-2 text-slate-600 text-sm">Sign in to file claims, track status and access your document vault.</p>

          <button
            onClick={handleLogin}
            className="mt-6 w-full flex items-center justify-center gap-3 bg-white border-2 border-slate-200 hover:border-[#003DA5] rounded-xl px-5 py-3.5 font-semibold text-slate-800 transition-all hover-lift"
            data-testid="google-signin-button"
          >
            <svg width="18" height="18" viewBox="0 0 18 18">
              <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
              <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
              <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
              <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
            </svg>
            Continue with Google
            <ChevronRight className="w-4 h-4 text-slate-400" />
          </button>

          <p className="mt-6 text-xs text-slate-500 leading-relaxed">
            By continuing you agree to our <button onClick={() => navigate("/legal/terms")} className="underline">Terms</button> and <button onClick={() => navigate("/legal/privacy")} className="underline">Privacy Policy</button>. We use Google to sign you in — we never see your password.
          </p>
        </div>
      </div>
    </div>
  );
}
